import { render } from "./Testimonial.vue?vue&type=template&id=6b428f42&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=6b428f42&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b428f42"],['__file',"src/scripts/view/portfolio/sections/Testimonial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b428f42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b428f42', __exports__)) {
    api.reload('6b428f42', __exports__)
  }
  
  module.hot.accept("./Testimonial.vue?vue&type=template&id=6b428f42&scoped=true", () => {
    api.rerender('6b428f42', render)
  })

}


export default __exports__